import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../context/AuthContext'
import { Link } from 'react-router-dom'

const Dashboard = () => {

    let {user, logOutUser, authTokens} = useContext(AuthContext)

    let [notes, setNotes] = useState([])


    useEffect(()=>{
      getNotes()
    }, [])

    let getNotes = async()=>{
      let response = await fetch('http://127.0.0.1:8000/notes', {
        method:'GET',
        headers:{
          'Content-Type':'application/json',
          'Authorization': 'Bearer ' + String(authTokens.access)
        }
      })
      let data = await response.json()
      if(response.status === 200){
        setNotes(data)
      }else if(response.statusText === 'Unauthorized'){
        logOutUser()
      }
      // setNotes(data)
    }

  return (
    <>
    
    {user ? (
      <p onClick={logOutUser}>Logout</p>
    ):(
      <Link to='login'>Login</Link>
    )
    }

    <div>Dashboard</div>
    

    <ul>
      {notes.map(note => (
        <li key={note.id}>{note.body}</li>
      ))}
    </ul>
    
    
    {user && 
    <p>Hello {user.username}</p>
    }
    </>
  )
}

export default Dashboard